import React from 'react';
import { colors } from 'spw-theme';
import styled from 'styled-components';

type PercentBarProps = {
  width?: string;
  height?: string;
  color: string;
};

const PercentBarContainer = styled.div`
  width: ${(props: PercentBarProps) => props.width};
  height: ${(props: PercentBarProps) => props.height};
  background-color: ${(props: PercentBarProps) => props.color};
`;

const CompletionPercentBar = styled(PercentBarContainer)``;

export const PercentBar = ({
  percentage,
  backgroundColor = colors.veryLightGray,
  completionColor,
  height,
  width = '100%',
  testingId,
}: {
  percentage: number;
  completionColor: string;
  backgroundColor: string;
  width?: string;
  height?: string;
  testingId?: string;
}) => (
  <PercentBarContainer
    color={backgroundColor}
    width={width}
    height={height}
    data-testid={testingId}
  >
    <CompletionPercentBar
      width={`${percentage}%`}
      color={completionColor}
      height={height}
    />
  </PercentBarContainer>
);
